import mixpanel from 'mixpanel-browser';
import React, { useState } from "react";
import { Popup } from "reactjs-popup";
import imageCross from "../../assests/corssSvg.svg";
import imageDownFille from "../../assests/downfilledSvg.svg";
import imageDownNotFilled from "../../assests/downnotfilledsvg.svg";
import imageUpNotFilled from "../../assests/downsvg.svg";
import imageCap from "../../assests/nocapSvg.svg";
import imageGlass from "../../assests/noglassSvg.svg";
import imageMask from "../../assests/nomaskSvg.svg";
import imageTick from "../../assests/ticksvg.svg";
import imageUpFille from "../../assests/upfilledSvg.svg";
import { payme_initial_token } from "../../constant";

mixpanel.init(payme_initial_token,{debug:true, api_host: process.env.REACT_APP_MIXPANEL_API_HOST})
function ModalBox(props) {
  const link = window.location.pathname
  const fnCondition = () =>{
    if(link==='/'){
      return "PAN screen"
    }
    else if(link === '/capturetips'){
          return "Selfie"
    }
    else{
      return "Aadhaar card"
    }
  }
  const {heading, fnClick, open, List, onChange, imagesVisible } = props;
  const [like, setLike] = useState(true);
  const [unlike, setUnlike] = useState(true);
  mixpanel.track("Viewed_Help_Screen", {"Screen Name":fnCondition(), "Platform" : window.screen.width <991 ?"App":"Web"})
  

  const eventOrganiser = (eventType) =>{
    if(eventType === 'close'){
      onChange(false)
      mixpanel.track("Interacted_Help_Screen", {"Screen Name":fnCondition(),"User Action":"Pop Up Closed",  "Platform" : window.screen.width <991 ?"App":"Web"})
    }
    else if(eventType === 'down') {
      setLike(false)
      setTimeout(()=>{onChange()}, 1000)
      mixpanel.track("Interacted_Help_Screen", {"Screen Name":fnCondition(), "User Action":"Thumbs Down", "Platform" : window.screen.width <991 ?"App":"Web"}) 
    }
    else if(eventType === 'up' ) {
      setUnlike(false)
      setTimeout(()=>{onChange()}, 1000)
      mixpanel.track("Interacted_Help_Screen", {"Screen Name":fnCondition(), "User Action":"Thumbs Up", "Platform" :window.screen.width <991 ?"App":"Web"}) 
    }
  }

  
  // useEffect(()=>{
            //document.getElementById("#popup-root").addEventListener("click", fnRun() );

  //     //document.getElementById("#popup-root").addEventListener("click", fnRun() );
  //     // document.addEventListener('waiting',async function handleClick (event) {
  //     // const hasClass = await event.target
  //     // console.log(hasClass,"hassclass")
  //     // })
  //   },[])
  return (
    <>
      <Popup open={open} modal onClose={()=>{onChange()}} closeOnDocumentClick={true}  >
        <div className="popup-box-center">
          <div className="popup-div">
            <div className="modal-header">
              <div className="cross">
                <img data-testid="crossButtonID" onClick={()=>{eventOrganiser('close')}} src={imageCross} className="crossImage" />
              </div>
            </div>
            <div className="list-section">
              <span className="headSpan"> {heading} </span>
              <div className="pt-3">
                 {List?.map((word, index) => {
                return (
                  <div key={index} className="tickSection">
                    <img src={imageTick}  />
                    <span className="section-span">
                      {word}
                    </span>
                  </div>
                );
              })}
              </div>
      
            </div>

            { imagesVisible && <div className="no-images pt-4">
              <img className='image-popup' src={imageMask} />
              <img className='image-popup' src={imageGlass} />
              <img className='image-popup' src={imageCap} />
            </div>}
            <div>
              <p className="popup-p-text">Was this information helpful?</p>
              <div className="like-unlike-section">
                 {unlike ? (
                  <img data-testid="thumbsUpID" onClick={()=>{eventOrganiser('up')}} src={imageDownNotFilled} />
                ) : (
                  <img src={imageUpFille} />
                )}
                {like ? (
                  <img data-testid="thumbsDownID" onClick={()=>{eventOrganiser('down')}} src={imageUpNotFilled } />
                ) : (
                  <img src={imageDownFille} />
                )}
               
              </div>
            </div>
          </div>
        </div>
      </Popup>
    </>
  );
}

export default ModalBox;
